import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "catalogue";

export const catalogueService = {
    getAllAuction,
};

function getAllAuction(auctionId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAllAuction/?auctionId=${auctionId}`, requestOptions).then(handleResponse);
}
